export const coursesPageLayoutByVariant = {
  desktop: {
    card: {
      maxWidth: 400,
    },
    pl: 152,
    pr: 152,
    px: 152,
  },
  laptop: {
    card: {
      maxWidth: 343,
    },
    pl: 24,
    pr: 24,
    px: 24,
  },
  mobile: {
    card: {
      maxWidth: 343,
    },
    pl: 16,
    pr: 16,
    px: 16,
  },
  tablet: {
    card: {
      maxWidth: 343,
    },
    pl: 24,
    pr: 24,
    px: 24,
  },
};
